import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useNavigate } from "react-router-dom";
import apiServiceHandler from "../../service/apiService";
import toastr from "toastr";

const keyTargets = [
  {
    id: 1,
    title: "Key 1",
    isBack: true,
    videoUrl:
      "https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/STG90+15+Defining+Key+4.mp4",
  },
  {
    id: 2,
    title: "Key 2",
    isBack: true,
    videoUrl: "",
  },
  {
    id: 3,
    title: "Key 3",
    isBack: true,
    videoUrl: "",
  },
  {
    id: 4,
    title: "Key 4",
    isBack: true,
    videoUrl: "",
  },
];

const Key4 = () => {
  const navigate = useNavigate();
  const textAreaRef = useRef(null);
  const [inputs, setInputs] = useState({});
  const prevMessagePage = localStorage.getItem("prevMessagePage")
  const [currentIndex, setCurrentIndex] = useState(() => {
    const savedIndex = localStorage.getItem("currentKeyIndex");
    return savedIndex ? JSON.parse(savedIndex) : 0;
  });
  const [currentDate, setCurrentDate] = useState(new Date())

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
    }
    localStorage.setItem("currentKeyIndex", JSON.stringify(currentIndex));
  }, [currentIndex]);

  const handleInputChange = (e) => {
    setInputs({
      ...inputs,
      [currentIndex]: e.target.value,
    });
  };

  const sendKey4 = async () => {
    const completed_inputs = Object.values(inputs).filter((input) =>
      Array.isArray(input)
        ? input[0].trim().length > 0
        : input.trim().length > 0
    );
    const key_progress =
      (Number(completed_inputs.length) / Number(keyTargets.length)) * 100;

    const payload = {
      key1: inputs[0] || "",
      key2: inputs[1] || "",
      key3: inputs[2] || "",
      key4: inputs[3] || "",
      progress: key_progress,
      date: currentDate
    };

    try {
      navigate("/message-page");
      const res = await apiServiceHandler("POST", "api/key4", payload);
    } catch (error) {}
  };

  const handleNext = (e) => {
    e.preventDefault();

    if (!inputs[currentIndex]) {
      toastr.error("Please fill the input field");
      return;
    }

    if (currentIndex === keyTargets.length - 1) {
      sendKey4();
    }
    setCurrentIndex((prevIndex) =>
      prevIndex < keyTargets.length - 1 ? prevIndex + 1 : prevIndex
    );
  };

  const handleBack = (e) => {
    e.preventDefault();
    if (currentIndex == 0) {
      navigate("/plan-for-success");
    }
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const skipStep = (e) => {
    e.preventDefault();

    if (currentIndex === keyTargets.length - 1) {
      sendKey4();
    }

    setCurrentIndex((prevIndex) =>
      prevIndex < keyTargets.length - 1 ? prevIndex + 1 : prevIndex
    );
  };

  useEffect(() => {
    const fetchData = async () => {

      const payload = {
        data: currentDate
      }

      try {
        const res = await apiServiceHandler("POST", "api/key4/fetch", payload);
        if (res.status && res.data) {
          setInputs({
            0: res.data[0].key1 || "",
            1: res.data[0].key2 || "",
            2: res.data[0].key3 || "",
            3: res.data[0].key4 || "",
          });
        }
      } catch (error) {
        console.log("Failed to fetch data")
      }
    };

    fetchData();
  }, []);

  return (
    <main className="auth">
      <div className="auth-layout">
        <div className="auth-view">
          <div className="driver-auth-view__container">
            <div className="driver-view">
              <div className="credo-heading">KEY4</div>
              <form className="driver-form">
                {keyTargets[currentIndex].videoUrl && (
                  <div className="driver-view__field">
                    <ReactPlayer
                      url={keyTargets[currentIndex].videoUrl}
                      config={{
                        vimeo: {
                          playerOptions: {
                            title: true,
                            byline: false,
                            portrait: false,
                          },
                        },
                      }}
                      controls={true}
                      width="100%"
                      height="100%"
                    />
                  </div>
                )}

                <h4 style={{ fontWeight: "lighter", color: "#fff" }}>
                  {keyTargets[currentIndex].title}
                </h4>
                <textarea
                  type="text"
                  className="credo-input"
                  ref={textAreaRef}
                  value={inputs[currentIndex] || ""}
                  onChange={handleInputChange}
                  style={
                    !keyTargets[currentIndex].videoUrl
                      ? { height: "380px", width: "500px" }
                      : {}
                  }
                />

                <div
                  style={{ display: "flex", gap: "1rem", alignItems: "center" }}
                >
                  <button
                    type="submit"
                    className="driver-btn"
                    onClick={handleBack}
                    style={
                      keyTargets[currentIndex].isBack
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <span className="driver-button__label">Back</span>
                  </button>

                  <button
                    type="submit"
                    className="driver-btn"
                    onClick={handleNext}
                  >
                    <span className="driver-button__label">SAVE</span>
                  </button>
                  <div
                    style={{
                      marginTop: "2rem",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                    onClick={skipStep}
                  >
                    skip
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Key4;
